import { iconsInjectionKeys as n } from "./composables/useIcon.js";
const o = {
  icons: {},
  flagIcons: {},
  creditCardIcons: {}
};
function i(c = o) {
  return {
    install(r) {
      r.provide(n.icons, {
        ...c?.icons
      }), r.provide(n.flags, {
        ...c?.flagIcons
      }), r.provide(n.creditCards, {
        ...c?.creditCardIcons
      });
    }
  };
}
export {
  i as createFds
};
